'use client'

import { useEffect, useState } from 'react'

import ResultsLeagues from 'components/ResultsLeagues'
import Spin from 'components/Spin'
import NoResults from 'components/NoResults'
import { GoBackAction } from 'components/GoBack'
import Timetable from 'components/Timetable'
import { ONE } from 'config/apis'
import { useLeagueContext } from 'utils/context'
import { publicGetRequest } from 'services/one'

const LeaguesResults = () => {
  const {
    categoryFilterSelected,
    divisionFilterSelected,
    dayFilterSelected,
    torDetails
  } = useLeagueContext()

  const [loading, setLoading] = useState()
  const [results, setResults] = useState([])
  const [matchDaysIdSelected, setMatchDaysIdSelected] = useState()
  const [matchData, setMatchData] = useState()
  const [teamsImgs, setTeamsImgs] = useState({})

  const getMatchData = async () => {
    const matchDataReq = await publicGetRequest({
      id: matchDaysIdSelected,
      endpoint: 'LEAGUES_MATCH'
    })
    setMatchData(matchDataReq)
  }
  useEffect(() => {
    if (matchDaysIdSelected) {
      getMatchData()
    }
  }, [matchDaysIdSelected])

  const getPageData = async () => {
    setLoading(true)
    const pageDataReq = await fetch(
      ONE.LEAGUES_RESULTS.replace('{id}', divisionFilterSelected).replace(
        '{day}',
        dayFilterSelected
      ),
      {
        ...ONE.HEADERS,
        next: { revalidate: 60 * 10 }
      }
    )
    const pageData = (await pageDataReq.json())?.Data?.Results
    setResults(pageData)
    setLoading(false)
  }

  useEffect(() => {
    if (dayFilterSelected) {
      getPageData()
    }
  }, [divisionFilterSelected, dayFilterSelected])

  useEffect(() => {
    setResults([])
  }, [categoryFilterSelected])

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mt-8 mb-40">
        {loading ? (
          <div className="flex justify-center my-20">
            <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
          </div>
        ) : results && !results?.length ? (
          <NoResults />
        ) : !matchDaysIdSelected ? (
          <ResultsLeagues
            matches={results}
            setOnClick={(e) => {
              const _matchDaysIdSelected =
                e.target.dataset?.daysid ||
                e.target.parentElement.dataset?.daysid ||
                e.target.parentElement.parentElement.dataset?.daysid ||
                e.target.parentElement.parentElement.parentElement.parentElement
                  .parentElement.dataset?.daysid
              setMatchDaysIdSelected(_matchDaysIdSelected)
              const matchDetails = results.find(
                ({ MatchDaysId }) => `${MatchDaysId}` === _matchDaysIdSelected
              )
              setTeamsImgs({
                local: matchDetails?.LocalImage,
                away: matchDetails?.AwayImage
              })
            }}
            torDetails={torDetails}
          />
        ) : (
          matchData && (
            <div className="max-w-6xl mx-auto">
              <div className="py-10">
                <GoBackAction action={() => setMatchDaysIdSelected()} />
              </div>
              <ResultsLeagues
                matches={[matchData.BasicData]}
                torDetails={torDetails}
                teamsImgs={teamsImgs}
              />
              <Timetable
                matches={matchData.Matches.map((match) => ({
                  noDate: `Partit ${match.Number}`,
                  result: `${match.LocalSet1}-${match.VisitingSet1} / ${
                    match.LocalSet2
                  }-${match.VisitingSet2} ${
                    !(
                      (match.LocalSet1 > match.VisitingSet1 &&
                        match.LocalSet2 > match.VisitingSet2) ||
                      (match.VisitingSet1 > match.LocalSet1 &&
                        match.VisitingSet2 > match.LocalSet2)
                    )
                      ? `/ ${match.LocalSet3}-${match.VisitingSet3}`
                      : ''
                  }`,
                  teams: [
                    {
                      name: match.LocalPlayerNameA,
                      imageUrl: match.LocalPlayerImgA
                    },
                    {
                      name: match.LocalPlayerNameB,
                      imageUrl: match.LocalPlayerImgB
                    },
                    {
                      name: match.VisitingPlayerNameA,
                      imageUrl: match.VisitingPlayerImgA
                    },
                    {
                      name: match.VisitingPlayerNameB,
                      imageUrl: match.VisitingPlayerImgB
                    }
                  ],
                  wo: match?.LocalWO || match?.VisitingWO,
                  jwo: match?.LocalJWO || match?.VisitingJWO,
                  injury: match?.LocalInjury || match?.VisitingInjury,
                  won: match?.WinningMatchPlayer
                }))}
              />
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default LeaguesResults
